import { StyleSheet } from 'react-native';

export const auditHistoryStyles = StyleSheet.create({
  outerContainer: {
    backgroundColor: '#F5F9FF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D8E7FB',
    overflow: 'hidden',
  },

  container: {
    backgroundColor: '#F5F9FF',
    borderRadius: 0,
  },

  header: {
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#D8E7FB',
  },

  title: {
    fontSize: 16,
    fontWeight: '700',
    color: '#2D2D2D',
    fontFamily: 'Inter',
    lineHeight: 22,
  },

  divider: {
    height: 1,
    backgroundColor: '#DADADA',
    width: '100%',
    paddingHorizontal: 20,
  },

  activityContainer: {
    flex: 1,
    paddingHorizontal: 20,
    paddingVertical: 16,
    maxHeight: 700,
  },

  logItem: {
    flexDirection: 'row',
    marginBottom: 24,
    alignItems: 'flex-start',
  },

  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 6,
    marginTop: 0,
    height: 20,
  },

  iconCircle: {
    width: 28,
    height: 28,
    borderRadius: 20,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D8E7FB',
    justifyContent: 'center',
    alignItems: 'center',
  },

  contentContainer: {
    flex: 1,
  },

  actionText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#2D2D2D',
    fontFamily: 'Inter',
    lineHeight: 20,
  },

  notesText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#4B4B4B',
    fontFamily: 'Inter',
    lineHeight: 18,
  },

  timestampText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#4B4B4B',
    fontFamily: 'Inter',
    lineHeight: 18,
  },

  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 40,
  },

  loadingText: {
    fontSize: 14,
    color: '#666',
    marginTop: 12,
    fontFamily: 'Inter',
  },

  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 40,
    paddingHorizontal: 20,
  },

  errorText: {
    fontSize: 14,
    color: '#D32F2F',
    marginTop: 12,
    textAlign: 'center',
    fontFamily: 'Inter',
  },

  retryButton: {
    marginTop: 16,
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: '#034895',
    borderRadius: 4,
  },

  retryButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    fontFamily: 'Inter',
  },

  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 40,
  },

  emptyText: {
    fontSize: 14,
    color: '#666',
    marginTop: 12,
    fontFamily: 'Inter',
  },
});
